"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "16",
  height: "14",
  viewBox: "0 0 16 14"
}, _react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M4.4.92a.5.5 0 00-.55-.84A8.3 8.3 0 000 7a8.3 8.3 0 003.84 6.92.5.5 0 10.55-.84A7.3 7.3 0 011 7 7.3 7.3 0 014.4.92zm7.75-.84a.5.5 0 10-.55.84A7.3 7.3 0 0115 7a7.3 7.3 0 01-3.4 6.08.5.5 0 10.56.84A8.3 8.3 0 0016 7 8.3 8.3 0 0012.15.08zM10.21 7c0 1.25-1 2.25-2.21 2.25S5.79 8.25 5.79 7s1-2.25 2.21-2.25 2.21 1 2.21 2.25zm1 0c0 1.8-1.43 3.25-3.21 3.25A3.23 3.23 0 014.79 7c0-1.8 1.43-3.25 3.21-3.25A3.23 3.23 0 0111.21 7z"
}));

exports.default = _default;